import { put, takeLatest, call, takeEvery, select } from '@redux-saga/core/effects';
import {
  get_recipe,
  get_recipe_error,
  get_recipe_success,
  get_comments,
  get_comments_error,
  get_comments_success,
  get_recommendations,
  get_recommendations_error,
  get_recommendations_success,
  get_guest_recipe,
  get_recipe_product_error,
  get_recipe_product_success,
  create_comment,
  create_comment_error,
  create_comment_success,
  create_reply,
  create_reply_error,
  create_reply_success,
  update_reply,
  update_reply_error,
  update_reply_success,
  delete_reply,
  delete_reply_error,
  delete_reply_success,
  delete_comment,
  delete_comment_error,
  delete_comment_success,
  update_comment,
  update_comment_error,
  update_comment_success,
  get_guest_recipe_success,
} from './reducer';

import api from '@service/DataService';
import toast from 'react-hot-toast';
import { getComments } from './selectors';

function* getRecipeSaga({ payload }) {
  try {
    const requestRes = yield call(api.get, `/recipes/${payload}`);
    const responseData = requestRes.data;
    const response = responseData.data;
    yield put({
      type: get_recipe_success.type,
      payload: response,
    });
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: get_recipe_error.type,
    });
  }
}

function* getGuestRecipeSaga({ payload }) {
  try {
    const requestRes = yield call(api.get, `recipes/${payload}/guest`);
    const responseData = requestRes.data;
    const response = responseData.data;
    yield put({
      type: get_guest_recipe_success.type,
      payload: response,
    });
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: get_recipe_error.type,
    });
  }
}

function* getCommentsSaga({ payload }) {
  try {
    const requestRes = yield call(api.get, `/comments/${payload}/recipe`);
    const responseData = requestRes.data;
    const response = responseData.data;
    yield put({
      type: get_comments_success.type,
      payload: response,
    });
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: get_comments_error.type,
    });
  }
}

function* getRecommendationsSaga({ payload }) {
  try {
    const requestRes = yield call(api.get, `/recipes/${payload}/recommendations`);
    const responseData = requestRes.data;
    const response = responseData.data;
    yield put({
      type: get_recommendations_success.type,
      payload: response,
    });
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: get_recommendations_error.type,
    });
  }
}

function* getRecipeProductSaga({ payload }) {
  try {
    const requestRes = yield call(api.get, `/products/${payload.product_id}`);
    const responseData = requestRes.data;
    const response = responseData.data;
    yield put({
      type: get_recipe_product_success.type,
      payload: response,
    });
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: get_recipe_product_error.type,
    });
  }
}

function* createCommentSaga({ payload }) {
  try {
    const { data, recipeId } = payload;
    const requestRes = yield call(api.post, `/comments/${recipeId}`, data);
    const responseData = requestRes.data;
    const response = responseData.data;
    toast.success(responseData.message);
    yield put({
      type: create_comment_success.type,
      payload: response,
    });
  } catch (error) {
    if (error.response.data) {
      toast.error(error.response.data.message);
      yield put({
        type: create_comment_error.type,
      });
    } else {
      yield put({
        type: create_comment_error.type,
      });
    }
  }
}

function* createReplySaga({ payload }) {
  try {
    const { data, commentId } = payload;
    const comments = yield select(getComments);
    const requestRes = yield call(api.patch, `/comments/${commentId}/reply`, data);
    const responseData = requestRes.data;
    const response = responseData.data;
    toast.success(responseData.message);
    const comment = comments.find((c) => c._id === commentId);
    let comment_payload = {
      ...comment,
      replys: [response, ...comment.replys],
    };
    yield put({
      type: create_reply_success.type,
      payload: comment_payload,
    });
  } catch (error) {
    if (error?.response?.data) {
      toast.error(error.response.data.message);
      yield put({
        type: create_reply_error.type,
      });
    } else {
      yield put({
        type: create_reply_error.type,
      });
    }
  }
}

function* updateReplySaga({ payload }) {
  try {
    const { data, rId } = payload;
    const comments = yield select(getComments);
    const requestRes = yield call(api.patch, `/comments/${rId}/reply/${rId}`, data);
    const responseData = requestRes.data;
    const response = responseData.data;
    let comment = comments.find((c) => c._id === response.replyTo);
    const replies = comment.replys.map((reply) => {
      if (reply._id === rId) {
        let temp = { ...reply };
        temp['body'] = response.body;
        return temp;
      }
      return reply;
    });
    comment = {
      ...comment,
      replys: replies,
    };
    toast.success(responseData.message);
    yield put({
      type: update_reply_success.type,
      payload: comment,
    });
  } catch (error) {
    console.log(error);
    if (error.response.data) {
      toast.error(error.response.data.message);
      yield put({
        type: update_reply_error.type,
      });
    } else {
      yield put({
        type: update_reply_error.type,
      });
    }
  }
}

function* updateCommentSaga({ payload }) {
  try {
    const { data, id } = payload;
    const requestRes = yield call(api.patch, `/comments/${id}`, data);
    const responseData = requestRes.data;
    const response = responseData.data;
    toast.success(responseData.message);
    yield put({
      type: update_comment_success.type,
      payload: response,
    });
  } catch (error) {
    if (error.response.data) {
      toast.error(error.response.data.message);
      yield put({
        type: update_comment_error.type,
      });
    } else {
      yield put({
        type: update_comment_error.type,
      });
    }
  }
}

function* deleteReplySaga({ payload }) {
  try {
    const { cId, rId } = payload;
    const comments = yield select(getComments);
    const requestRes = yield call(api.delete, `/comments/${cId}/reply/${rId}`);
    const responseData = requestRes.data;
    const response = responseData.data;
    toast.success(responseData.message);
    const comment = comments.find((c) => c._id === cId);
    const replies = comment.replys.filter((r) => r._id !== response._id);
    let comment_payload = {
      ...comment,
      replys: replies,
    };
    yield put({
      type: delete_reply_success.type,
      payload: comment_payload,
    });
  } catch (error) {
    console.log(error);
    if (error.response.data) {
      toast.error(error.response.data.message);
      yield put({
        type: delete_reply_error.type,
      });
    } else {
      yield put({
        type: delete_reply_error.type,
      });
    }
  }
}

function* deleteCommentSaga({ payload }) {
  try {
    const requestRes = yield call(api.delete, `/comments/${payload}`);
    const responseData = requestRes.data;
    const response = responseData.data;
    toast.success(responseData.message);
    yield put({
      type: delete_comment_success.type,
      payload: response,
    });
  } catch (error) {
    if (error.response.data) {
      toast.error(error.response.data.message);
      yield put({
        type: delete_comment_error.type,
      });
    } else {
      yield put({
        type: delete_comment_error.type,
      });
    }
  }
}

function* recipeSagas() {
  yield takeLatest(get_recipe.type, getRecipeSaga);
  yield takeLatest(get_comments.type, getCommentsSaga);
  yield takeLatest(get_recommendations.type, getRecommendationsSaga);
  yield takeLatest(get_recipe_success.type, getRecipeProductSaga);
  yield takeLatest(get_guest_recipe.type, getGuestRecipeSaga);

  // Comments
  yield takeEvery(create_comment.type, createCommentSaga);
  yield takeEvery(create_reply.type, createReplySaga);
  yield takeEvery(update_reply.type, updateReplySaga);
  yield takeEvery(delete_reply.type, deleteReplySaga);
  yield takeEvery(delete_comment.type, deleteCommentSaga);
  yield takeEvery(update_comment.type, updateCommentSaga);
}

export default recipeSagas;
